var _style, _rect, _rect2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .logo-text { font-family: 'Exo 2', sans-serif; font-weight: 700; font-size: 24px; }\n    .primary { fill: #F05A28; }\n    .secondary { fill: #0E1330; }\n    .accent { fill: #00ADEE; }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 30,
    height: 30,
    className: "primary",
    rx: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 10,
    width: 30,
    height: 30,
    className: "accent",
    rx: 5,
    opacity: 0.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 32,
    className: "logo-text secondary"
  }, "TechRamp")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0c8a08d85a924095f64b904d5dfb6ba.svg";
export { ForwardRef as ReactComponent };